import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy , DestroyRef, inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription , Subject, takeUntil} from 'rxjs';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { HttpService, PermissionService } from '../..';
import { MODULES } from '../../config/enum';
import { PathConfig } from '../../config/path.config';
import { ClientDetailService } from '../../services/client-detail-service';
import { QBTokenChangeService } from '../../services/qb_token_change-service';
import { UserService } from '../../services/user.service';
import { ClientUtils } from '../../utils/clientUtil';

@Component({
  selector: 'app-left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false

})

export class LeftNavigationComponent implements OnInit , AfterViewInit{
  private readonly destroy$ = new Subject<void>();

  private readonly destroyRef = inject(DestroyRef);

  defaultTab:string = 'menu-servicing';
  private subscription!: Subscription
  clientId: string;
  isLendisoftClient: boolean = false;
  USER_PERMISSIONS:Array<any> = [];
  MODULES = MODULES;
  settingMenu:boolean = false;
  queueMenu: boolean = false;
  scoringModuleMenu:boolean = false;
  importsMenu:boolean = false;
  vendorConfigurationMenu:boolean = false;
  qb_url: string = '';
  qb_token: any = null;
  canAccessLoanInformation:boolean = false;
  addLoanViaWizard: boolean = false;
  isBaseClient: boolean = false;


  constructor(
    private router:Router, private activeRoute: ActivatedRoute , private clientDetailService:ClientDetailService,
     private userService:UserService,
     public permissionService:PermissionService,
     private qbSharingService: QBTokenChangeService,
     private modalService: NgbModal,
     private httpService: HttpService,
     private translateService:TranslateService
     ) {

    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en');
  // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
   this.clientId = this.clientDetailService.CLIENT_ID;
   this.qb_token = this.clientDetailService?.clientDetail?.token ?? null;

   //default tab to be opened
   this.defaultTab = this.getParentGroup(router.url);

   //user permissions
   this.USER_PERMISSIONS = this.userService.PERMISSIONS;
   this.getQboUrl();

    //  this.canAccessLoanInformation = this.permissionService.isEdit('loan_information');
    this.canAccessLoanInformation = this.permissionService.isSpecialPermission('can_add_new_loans');
  }

  ngOnInit(): void {
    this.isLendisoftClient = ClientUtils.isLoginAsClient(this.clientDetailService, this.userService);

    this.addLoanViaWizard = this.clientDetailService?.clientDetail?.settings?.add_new_loan_preference  === 'WIZARD' ? true : false;
    this.isBaseClient = this.clientDetailService?.clientDetail?.is_default === 'YES'? true : false;

    this.subscription = this.qbSharingService.dataObservable$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.qb_token = this.clientDetailService?.clientDetail?.token ?? null;
        this.qb_url=data[1];
    });

    this.router.events.subscribe(() => {
      this.defaultTab = this.getParentGroup(this.router.url);
    });
  }

  ngAfterViewInit(): void {
    // keep the previous working behavior: initialize from the route
  }

  // get parent category
  getParentGroup(url:string):string{
    const normalizedUrl = url || '';
    let defaultTab = 'menu-servicing';
    if(normalizedUrl.indexOf('/servicing') > -1 || normalizedUrl.indexOf('/home/servicing') > -1){
      defaultTab = 'menu-servicing';

      //reselect the menu as per selected module
      if(normalizedUrl.indexOf('/servicing/queues') > -1 || normalizedUrl.indexOf('/home/servicing/queues') > -1){
        this.queueMenu = true;
      }else if(normalizedUrl.indexOf('/servicing/settings') > -1 || normalizedUrl.indexOf('/home/servicing/settings') > -1){
        this.settingMenu = true;
        if(normalizedUrl.indexOf('/servicing/settings/scoring-module') > -1 || normalizedUrl.indexOf('/home/servicing/settings/scoring-module') > -1){
          this.scoringModuleMenu = true;
        }else if(normalizedUrl.indexOf('/servicing/settings/import') > -1 || normalizedUrl.indexOf('/home/servicing/settings/import') > -1){
          this.importsMenu = true;
        }
      }

    } else if(normalizedUrl.indexOf('/report') > -1 || normalizedUrl.indexOf('/home/report') > -1){
      defaultTab = 'menu-report';
    } else if(normalizedUrl.indexOf('/configuration') > -1 || normalizedUrl.indexOf('/home/configuration') > -1){
      defaultTab = 'menu-configuration';
    }else if(normalizedUrl.indexOf('/lendisoft-configuration') > -1 || normalizedUrl.indexOf('/home/lendisoft-configuration') > -1){
      defaultTab = 'menu-lendisoft-configuration';
    }else if(normalizedUrl.indexOf('/logs') > -1 || normalizedUrl.indexOf('/home/logs') > -1){
      defaultTab = 'menu-logs';
    }
    return defaultTab;
  }

  goToRoute(route: string): void {
   this.router.navigate([this.clientId + route]);
  //  window.location.href = this.clientId + route;
  }

  validateRoute(route: string){
    return this.router.url.includes(route);
  }


  showConfirmation() {
    if (![null,undefined,''].includes(this.qb_url)) {
      const modalRef = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        size: 'sm',
      });
      modalRef.componentInstance.confirmationBoxTitle = this.translateService.instant('Are you sure?');
      modalRef.componentInstance.confirmationMessage =
        `${this.translateService.instant('All You are being directed to an external website. Please be aware that you are leaving our platform, and the content or security of the destination site may not be under our control.')}<br><br>${this.translateService.instant('Do you want to proceed?')}`;
      modalRef.result.then((response) => {
        if (response) {
          window.open(this.qb_url+'/'+this.qb_token, '_blank');
        }

      });
    }
  }

  getQboUrl() {
    const qbo_URL = `${PathConfig.CUSTOM_VENDOR_CONFIG}?config_data=qb`;
      this.httpService.get(qbo_URL).subscribe((res) => {
      this.qb_url = res?.qb_configuration?.url;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}